import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

export const SectionLoader: React.FC<{ message?: string }> = ({ message }) => (
  <div
    style={{
      minHeight: "60vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
    }}
  >
    <CircularProgress size={48} />
    {message && <div style={{ marginTop: 24, fontSize: 18 }}>{message}</div>}
  </div>
);
